__turbopack_context__.v({
  "default": "ItineraryCardTags-module__PYjvqW__default",
  "hero": "ItineraryCardTags-module__PYjvqW__hero",
  "list": "ItineraryCardTags-module__PYjvqW__list",
  "positive": "ItineraryCardTags-module__PYjvqW__positive",
  "tag": "ItineraryCardTags-module__PYjvqW__tag",
  "tagIcon": "ItineraryCardTags-module__PYjvqW__tagIcon",
});
